import ReactPaginate from 'react-paginate';
import { ChevronLeft, ChevronRight } from 'lucide-react';

interface PaginationProps {
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
}

export function Pagination({
  currentPage,
  totalPages,
  onPageChange,
}: PaginationProps) {
  if (totalPages <= 1) return null;

  return (
    <ReactPaginate
      pageCount={totalPages}
      forcePage={currentPage - 1}
      onPageChange={({ selected }) => onPageChange(selected + 1)}
      pageRangeDisplayed={3}
      marginPagesDisplayed={1}
      previousLabel={<ChevronLeft className="h-4 w-4" />}
      nextLabel={<ChevronRight className="h-4 w-4" />}
      breakLabel="..."
      containerClassName="flex justify-center items-center space-x-2 mt-8"
      pageClassName=""
      pageLinkClassName="px-3 py-1 rounded bg-accent hover:bg-accent/80 block"
      activeClassName=""
      activeLinkClassName="!bg-primary text-white"
      previousClassName=""
      previousLinkClassName="px-2 py-1 rounded bg-accent hover:bg-accent/80 block disabled:opacity-50 disabled:pointer-events-none"
      nextClassName=""
      nextLinkClassName="px-2 py-1 rounded bg-accent hover:bg-accent/80 block disabled:opacity-50 disabled:pointer-events-none"
      breakClassName=""
      breakLinkClassName="px-2 py-1 text-muted-foreground"
      disabledClassName="opacity-50 pointer-events-none"
    />
  );
}
